import surfaceStore from '../store/surfaceStore';
import { CalendarSurfaceStore } from 'owa-calendar-surface-dategrid';

export default function getCalendarSurfaceStore(): CalendarSurfaceStore {
    return surfaceStore;
}
